import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import {inputRules} from '@/plugins/rule'
import helpers from '@/helpers/index.js'
import PluginHelper from '@/helpers/PluginHelper'
import utils from '@/plugins/utils'
import dialog from '@/plugins/dialog'
import adminDialog from '@/plugins/dialog'
import alert from '@/plugins/alert'
import loading from '@/plugins/loading'
import VueHtmlToPaper from 'vue-html-to-paper'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueMask from 'v-mask'
import {get} from 'lodash'
import socket from './plugins/socket'

Vue.filter('ddmmyyyy', value => (value ? moment(value).format('DD/MM/YYYY') : ''))
Vue.filter('ddmmyyyyhhmm', value => (value ? moment(value).format('DD/MM/YYYY HH:mm') : ''))
Vue.filter('getTextStatusSurvey', status => ({draft: 'Chưa mở', open: 'Đã mở', close: 'Đã đóng'}[status] || ''))
Vue.filter('getColorStatusSurvey', status => ({draft: 'grey', open: 'success', close: 'error'}[status] || 'grey'))
Vue.filter('surveyIsExpiredText', value => (value ? 'Hết hạn' : 'Còn hạn'))
Vue.filter('surveyExpireColor', value => (value ? 'error' : 'success'))

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=no', 'scrollbars=no'],
  styles: ['@/modules/active-code/PrintActiveCode.css']
}

Vue.use(VueMask)
Vue.use(
  PluginHelper.create({
    $utils: utils,
    $rules: inputRules,
    $dialog: dialog,
    $adminDialog: adminDialog,
    $alert: alert,
    $loading: loading,
    $baseUrl: process.env.VUE_APP_API_ENDPOINT,
    $moment: moment,
    $helpers: helpers,
    $auth: store.state.auth,
    $get: get,
    $socket: socket
  })
)

Vue.use(VueHtmlToPaper, options)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
